import { MainPageBlockWithResizes } from '../interfaces/main-page-block';

export class BlocksState {
  pageBlocks: MainPageBlockWithResizes[] = [];
}
